
import { useEffect, useState } from 'react';
import { apiEndpoint } from "helpers/url_helper";

import Select from "react-select";
import moment from "moment";
const CampusList = props => {
  const [error, setError] = useState(null);
  //const [isLoaded, setIsLoaded] = useState(false);
  const [items, setItems] = useState([]);
  const [selectedCampusval, setSelected] = useState('');

  const handleCampusChange = event => {
    //console.log('Label 👉️', event.target.selectedOptions[0].label);
    //console.log(event.target.value);
    setSelected(event.target.value);
    props.setCampusValue(event.target.value);
    // LocationList(event.target.value);
    const element = <LocationList campusid={event.target.value} />;
  };

  

  

  // Note: the empty deps array [] means
  // this useEffect will run once
  // similar to componentDidMount()
  //useEffect(() => {

    // UserValidated
    fetch(apiEndpoint+"/GetCampusList",
      {
       method: 'POST',
       headers: {
         'Content-Type': 'application/json',
       },
       body: JSON.stringify({
         "strToken": sessionStorage.getItem("Clear_AuthUser")
         
       })
     })    
     .then(res => res.json())
    .then(
      (result) => {
        // setIsLoaded(true);
        //console.log(result);
        //console.log(JSON.parse(result.Locations));
        setItems(JSON.parse(result.CampusList));
      },
      // Note: it's important to handle errors here
      // instead of a catch() block so that we don't swallow
      // exceptions from actual bugs in components.
      (error) => {
        // setIsLoaded(true);
        setError(error);
      }
    )
  //}, [])

  if (error) {
    return <div>Error: {error.message}</div>;
  } //else if (!isLoaded) {
  //   return <div>Loading...</div>;
  //} 
  else {
    return (
      <div>
        <select value={selectedCampusval} onChange={handleCampusChange} className="form-control">
          {
            items.map(item => (
              <option value={item.CampusID}>{item.CampusName}</option>
            ))}
        </select>
      </div>
    );
  }
}

const LocationList = props => {
  const [error, setError] = useState(null);
  const [items, setItems] = useState([]);
  const [selectedLocval, setSelected] = useState('');

  const handleLocChange = event => {
    //console.log('Label 👉️', event.target.selectedOptions[0].label);
    //console.log(event.target.value);
    setSelected(event.target.value);
    props.setLocValue(event.target.value);

  };

  // Note: the empty deps array [] means
  // this useEffect will run once
  // similar to componentDidMount()
  useEffect(() => {
    console.log(props.campusid);
    var intCampusID = props.campusid;

    // UserValidated
    fetch(apiEndpoint+"/GetLocationList", { 
      method: 'POST', 
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      "intCampusID": intCampusID,
      "strToken": sessionStorage.getItem("Clear_AuthUser")
    })
    
    })
      .then(res => res.json())
      .then(
        (result) => {
          //console.log(result);

          setItems(JSON.parse(result.Locations));
          //console.log(JSON.parse(items[0]["LocationID"]));
          //props.setLocValue(JSON.parse(items[0]["LocationID"]));
          // setSelected(JSON.parse(items[0]["LocationID"]));
        },
        // Note: it's important to handle errors here
        // instead of a catch() block so that we don't swallow
        // exceptions from actual bugs in components.
        (error) => {
          setError(error);
        }
      )
  }, [])

  if (error) {
    return <div>Error: {error.message}</div>;
  }
  else {
    return (
      <div>
        <select value={selectedLocval} onChange={handleLocChange} className="form-control">
          {
            items.map(item => (
              <option value={item.LocationID} selected>{item.LocationName}</option>
            ))}
        </select>
      </div>
    );
  }
}

const ReportType = (props) => {
  const ReportTypeitems = [
    {
      value: 1,
      label: "Daily"
    },
    {
      value: 2,
      label: "Weekly"
    },
    {
      value: 3,
      label: "Monthly"
    },
    // {
    //   value:4,
    //   label:"Custom"
    // }
  ];
  // 👇️ initial value of empty string (first option)
  const [SelectedReportTypeitem, setSelectedReportTypeItem] = useState({ value: 1, label: "Daily" });
  const [FromDtTm, setFrmDttm] = useState(moment().format("YYYY-MM-DD 00:00"));
  const [ToDtTm, setToDttm] = useState(moment().format("YYYY-MM-DD HH:mm"));
  const handleReportTypeChange = event => {
    //console.log('Label 👉️', event.label);
    console.log(event);
    setSelectedReportTypeItem(event);
    props.setReportType(event.value);
    const startTime = document.getElementById('from-datetime-local-input');
    const endTime = document.getElementById('to-datetime-local-input');
    var now = new Date();
    now.setMinutes(now.getMinutes() - now.getTimezoneOffset());
    endTime.value = now.toISOString().slice(0,16);
    switch(event.value){
    case 1:   
         var d=new Date();
       
        d.setHours(0, 0, 0, 0)
        d.setMinutes(d.getMinutes() - d.getTimezoneOffset())
        startTime.value=d.toISOString().slice(0,16)
      endTime.value = now.toISOString().slice(0,16); 

      setFrmDttm(d.toISOString().slice(0,16))
      setToDttm(now.toISOString().slice(0,16))
      break;
    case 2:
      var d = new Date();
       
       d.setDate(d.getDate() - 7);
      // Zero the time component
       d.setHours(0, 0, 0, 0);
       d.setMinutes(d.getMinutes() - d.getTimezoneOffset());
       var oneMonthAgo = d.toISOString();
       document.getElementById('from-datetime-local-input').value=oneMonthAgo.slice(0,16)
       d.setMinutes(d.getMinutes() - d.getTimezoneOffset());
       endTime.value = now.toISOString().slice(0,16);
       setFrmDttm(oneMonthAgo.slice(0,16))
       setToDttm(now.toISOString().slice(0,16))
       break;  
    case 3:
        var d = new Date();
       
       d.setMonth(d.getMonth() - 1);
       d.setHours(0, 0, 0, 0);
       d.setMinutes(d.getMinutes() - d.getTimezoneOffset());
         var oneMonthAgo = d.toISOString();
          document.getElementById('from-datetime-local-input').value=oneMonthAgo.slice(0,16)
          d.setMinutes(d.getMinutes() - d.getTimezoneOffset());
          endTime.value = now.toISOString().slice(0,16);

          setFrmDttm(oneMonthAgo.slice(0,16))
     setToDttm(now.toISOString().slice(0,16))
          break;
    case 4:
        break;
   }
  };
  const fromDateChange=(value)=>{
    setFrmDttm(value)
    console.log(SelectedReportTypeitem)
}
const toDateChange=(value)=>{
setToDttm(value)
}
  return (
    <Select  inputProps={{ id: 'ReportType' }}  value={SelectedReportTypeitem}  options={ReportTypeitems} onChange={handleReportTypeChange}></Select>
  );
};

const SpeedType = (props) => {
  const SpeedTypeitems = [
    {
      value: 1,
      label: "Default"
    },
    {
      value: 2,
      label: "Custom"
    }
  ];
  // 👇️ initial value of empty string (first option)
  const [SelectedSpeedTypeitem, setSelectedSpeedTypeItem] = useState({ value: 1, label: "Default" });

  const handleSpeedTypeChange = event => {
    //console.log('Label 👉️', event.label);
    console.log(event);
    setSelectedSpeedTypeItem(event);
    props.setSpeedType(event.value);
    if (event.value == '2') {
      const boxes = document.getElementsByClassName('customspeed');
      for (const box of boxes) {
        box.style.display = "block";
      }
    }
    else {
      const boxes = document.getElementsByClassName('customspeed');
      for (const box of boxes) {
        box.style.display = "none";
      }
    }
  };

  return (
    <Select value={SelectedSpeedTypeitem} options={SpeedTypeitems} onChange={handleSpeedTypeChange}></Select>

  );
};

const SearchData = (props) => {
  const [error, setError] = useState(null);

  // Note: the empty deps array [] means
  // this useEffect will run once
  // similar to componentDidMount()
  useEffect(() => {
    // UserValidated
    fetch(apiEndpoint+"/GetViolationLogs",
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          "intCampusID": selectedCampus,// 1,
          "intLocationID": selectedLoc,//1,
          "intReportType": selectedReportType,//1,
          "intSpeedType": selectedSpeedType,//1,
          "boolOnlyANPR": true,
          "strToken": sessionStorage.getItem("Clear_AuthUser")
        })
      })
      .then(res => res.json())
      .then(
        (result) => {
          //sessionStorage.setItem("authUser",JSON.stringify(result.strNewToken))
          //console.log(result);
          //setViolations(JSON.parse(result.Violations));
          props.setViolations(JSON.parse(result.Violations));
        },
        // Note: it's important to handle errors here
        // instead of a catch() block so that we don't swallow
        // exceptions from actual bugs in components.
        (error) => {
          setError(error);
        }
      )
  }, [])

}

export { CampusList, LocationList, ReportType, SpeedType, SearchData }
